import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '../../../config/queryKeys'
import { getGameScoreboard } from '../../../services/game/timelineServices'

interface UseGameScoreboardOptions {
  gameId?: string | null
  isLive?: boolean
}

const useGameScoreboard = ({
  gameId,
  isLive = false,
}: UseGameScoreboardOptions) => {
  return useQuery({
    queryKey: queryKeys.gameScoreboard.byGame(gameId),
    queryFn: () => getGameScoreboard(gameId!),
    enabled: Boolean(gameId),
    staleTime: 0,
    refetchInterval: isLive ? 20000 : false,
  })
}

export default useGameScoreboard
